import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const cryptoNewsHeaders = {
  // "X-BingApis-SDK": "true",
  // "X-RapidAPI-Host": "bing-news-search1.p.rapidapi.com",
  // "X-RapidAPI-Key": "a5da55e53emsh89a71413ab2182cp107d94jsnb234c038edcc",
  "X-BingApis-SDK": "true",
  "X-RapidAPI-Key": "041d879d9bmsh2ab2e4180d0a37ap18b709jsn0f94b275c352",
  "X-RapidAPI-Host": "bing-news-search1.p.rapidapi.com",
};

const baseUrl = "https://bing-news-search1.p.rapidapi.com";
const createRequest = (url) => ({ url, headers: cryptoNewsHeaders });

export const cryptoNewsApi = createApi({
  reducerPath: "cryptoNewsApi",
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getCryptoNews: builder.query({
      query: ({ newsCategory, count }) =>
        createRequest(
          `/news/search?q=${newsCategory}&safeSearch=Off&textFormat=Raw&freshness=Day&count=${count}`
        ),
    }),
  }),
});
export const { useGetCryptoNewsQuery } = cryptoNewsApi;
